import Flickity from 'flickity'

jQuery(document).ready(function ($) {
	if ($(".wrongs-slider").length) {
		$(".wrongs-slider").each(function () {
			if ($(this).find(".slide").length > 1) {

				let maxHeight = 0;
				$(this).find(".slide").each(function () {
					var slideHeight = $('.inner', this).height();
					maxHeight = Math.max(maxHeight, slideHeight);
				})
				$(this).find(".slide").height(maxHeight);

				var $slider = $(this);

				let flkty = new Flickity(this, {
					wrapAround: true,
					pageDots: true,
					cellAlign: "center",
					accessibility: false,
					draggable: false,
					freeScroll: true,
					contain: true,
					wrapAround: true,
					resize: true
				});

				// animate other wrongs after changing slides
				flkty.on('settle', function (index) {
					var $img = $('.slide', $slider).eq(index).find('img');
					$img.attr('src', $img.data('animated-src'));
				});
			}
		});

		// animate first wrong we right when scrolled to
		// this assumes only one of these sliders per page
		function animateFirstSlide() {
			var $triggerEl = $('.wrongs-slider .is-selected img');
			if ($triggerEl.length > 0) {
				var hT = $triggerEl.offset().top,
					hH = $triggerEl.outerHeight(),
					wH = $(window).height(),
					wS = $(this).scrollTop();
				if (wS > (hT + hH - wH)) {
					$triggerEl.attr('src', $triggerEl.data('animated-src'));
					$(window).off('scroll', animateFirstSlide); // remove event handler after doing this once
				}
			} else {
				$(window).off('scroll', animateFirstSlide); // remove event handler if n/a
			}
		}
		$(window).on('scroll', animateFirstSlide);
	}
});